class AjaxFormController {
  constructor({
    formId,
    leftEyeId,
    rightEyeId,
    summarySelector,
    radioSelector,
    productGridSelector,
    collectionHandleSelector,
  }) {
    this.selectors = {
      formId,
      leftEyeId,
      rightEyeId,
      summarySelector,
      radioSelector,
      productGridSelector,
      collectionHandleSelector,
    };

    this.selectedBundle = null;
    this.selectedColor = null;

    this.lastSavedLeftEye = null;
    this.lastSavedRightEye = null;

    this.initElements();
    this.attachEventListeners();
    this.initializeBundleFilter();
    this.setInitialPrescriptionValues();
  }

  setInitialPrescriptionValues() {
    if (this.leftEyeInput && this.rightEyeInput) {
      this.lastSavedLeftEye = this.leftEyeInput.value.trim();
      this.lastSavedRightEye = this.rightEyeInput.value.trim();
    }
  }

  initElements() {
    const {
      formId,
      leftEyeId,
      rightEyeId,
      summarySelector,
      radioSelector,
      productGridSelector,
      collectionHandleSelector,
    } = this.selectors;

    this.form = document.getElementById(formId);
    this.leftEyeInput = document.getElementById(leftEyeId);
    this.rightEyeInput = document.getElementById(rightEyeId);
    this.summaryWrapper = document.querySelector(summarySelector);
    this.radios = document.querySelectorAll(radioSelector);
    this.productGrid = document.querySelector(productGridSelector);
    this.collectionHandle = document.querySelector(
      collectionHandleSelector,
    )?.dataset.collectionHandle;

    this.saveButton = this.form?.querySelector(
      ".product-personalization__save-btn",
    );
    this.valueSpans =
      this.summaryWrapper?.querySelectorAll(
        ".product-personalization__value",
      ) || [];
    this.editButton = this.summaryWrapper?.querySelector(
      ".product-personalization__edit",
    );
    this.colorRadios = document.querySelectorAll(".color-filter");
    this.selectedBundleElement = document.querySelector(
      'input[name="bundle"]:checked',
    );
    this.selectedColorElement = document.querySelector(
      'input[name="color-filter"]:checked',
    );
    this.addToBundleButtons = document.querySelectorAll(".add-to-bundle-btn");

    this.updateRadioButtonsState();
    this.overlaySelector = ".bundle-overlay";
  }

  attachEventListeners() {
    if (this.form) {
      this.form.addEventListener("submit", this.handleSave.bind(this));
    }

    if (this.editButton) {
      this.editButton.addEventListener("click", this.showForm.bind(this));
    }

    this.radios.forEach((radio) => {
      radio.addEventListener("change", () => {
        this.selectedBundle = radio.value;
        this.handleFilterChange();
        this.updateCartAttribute("Selected Bundle", radio.value);
        window.dispatchEvent(new Event("storageUpdate"));
        updateBundleContentVisibility();
      });
    });

    this.colorRadios.forEach((radio) => {
      radio.addEventListener("change", () => {
        if (radio.value === "all") {
          this.selectedColor = null;
        } else {
          this.selectedColor = radio.value;
        }
        this.handleFilterChange();
        this.updateCartAttribute("Selected Filter", radio.value);
        this.toggleVisibility(this.summaryWrapper, true);
        this.updateRadioButtonsState();
        window.dispatchEvent(new Event("storageUpdate"));
        updateBundleContentVisibility();
      });
    });
  }

  addOverlay() {
    if (document.querySelector(this.overlaySelector)) return;
    const overlayTemplate = document.createElement("div");
    overlayTemplate.className = "bundle-overlay";
    const selectors = [
      ".bundle-select-wrapper",
      ".bundle-filter-wrapper",
      ".collection-wrapper",
    ];
    selectors.forEach((selector) => {
      const section = document.querySelector(selector);
      if (!section) return;
      if (
        section.classList.contains("collection-wrapper") &&
        !section.querySelector(".collection-content.bundle-content")
      ) {
        return;
      }
      section.style.position = "relative";
      const sectionOverlay = overlayTemplate.cloneNode();
      sectionOverlay.className = "bundle-overlay";
      section.appendChild(sectionOverlay);
    });
  }

  removeOverlay() {
    document
      .querySelectorAll(this.overlaySelector)
      .forEach((el) => el.remove());
  }

  showForm(event) {
    event.preventDefault();
    this.toggleVisibility(this.summaryWrapper, false);
    this.toggleVisibility(this.form, true);
    this.addOverlay();
  }

  toggleVisibility(element, show) {
    if (!element) return;
    element.classList.toggle("is-visible", show);
    element.classList.toggle("is-hidden", !show);
    if (element === this.form && !show) {
      this.removeOverlay();
    }
  }

  async makeFetchRequest(url, options = {}) {
    try {
      const response = await fetch(url, {
        headers: { "Content-Type": "application/json" },
        ...options,
      });
      return await response.json();
    } catch (error) {
      console.error(`Fetch error at ${url}:`, error);
      throw error;
    }
  }

  async handleSave(event) {
    event.preventDefault();

    const leftEye = this.leftEyeInput.value.trim();
    const rightEye = this.rightEyeInput.value.trim();
    if (!leftEye || !rightEye) return;

    const prescriptionChanged =
      leftEye !== this.lastSavedLeftEye || rightEye !== this.lastSavedRightEye;

    try {
      await this.makeFetchRequest("/cart/update.js", {
        method: "POST",
        body: JSON.stringify({
          attributes: {
            "Left Eye": leftEye,
            "Right Eye": rightEye,
          },
        }),
      });

      if (prescriptionChanged) {
        localStorage.removeItem("bundleProducts1Day");
        localStorage.removeItem("bundleProducts3Month");
        window.dispatchEvent(new Event("storageUpdate"));
      }
      if (
        window.bundleManager &&
        typeof window.bundleManager.updateBundleSlots === "function"
      ) {
        window.bundleManager.updateBundleSlots();
      }

      this.updateSummary(leftEye, rightEye);
      this.toggleVisibility(this.form, false);
      this.toggleVisibility(this.summaryWrapper, true);
      this.updateRadioButtonsState();
      document.querySelectorAll(".add-to-bundle-btn").forEach((btn) => {
        btn.classList.remove("hide");
        btn.disabled = false;
      });
      document
        .querySelectorAll(".quantity-selector")
        .forEach((qty) => qty.classList.add("hide"));
      updateBundleContentVisibility();

      if (
        window.bundleManager &&
        typeof window.bundleManager.toggleFreeTags === "function"
      ) {
        window.bundleManager.toggleFreeTags(false);
      }

      this.lastSavedLeftEye = leftEye;
      this.lastSavedRightEye = rightEye;

      this.filterProductCardsByPrescription(leftEye, rightEye);

      const bundleCards = document.querySelectorAll("[data-bundle-product]");
      for (const card of bundleCards) {
        const product = JSON.parse(card.dataset.bundleProduct);
        let matchedVariant = false;
        let matchedVariantAvailable = true;
        if (Array.isArray(product.variants)) {
          for (const variant of product.variants) {
            if (variant.title === leftEye || variant.title === rightEye) {
              matchedVariant = true;
              if (variant.available === false) {
                matchedVariantAvailable = false;
              }
            }
          }
        }
        const addBtn = card
          .closest("[data-product-id]")
          ?.querySelector(".add-to-bundle-btn");
        const soldOutTag = card
          .closest("[data-product-id]")
          ?.querySelector(".product-card__sold-out");

        if (addBtn) {
          if (matchedVariant && matchedVariantAvailable === false) {
            addBtn.classList.add("sold-out");
            addBtn.disabled = true;
            addBtn.textContent = "Sold Out";
            if (soldOutTag) {
              soldOutTag.classList.remove("hide");
            }
          } else {
            addBtn.classList.remove("sold-out");
            addBtn.disabled = false;
            addBtn.textContent = "+ Add to bundle";
            if (soldOutTag) {
              soldOutTag.classList.add("hide");
            }
          }
        }
      }
    } catch (error) {
      console.error("Cart update failed:", error);
    }
  }

  async handleFilterChange() {
    try {
      this.showLoadingState();
      const tags = [];

      if (this.selectedColor && this.selectedColor !== "all") {
        tags.push(this.selectedColor);
      }

      if (this.selectedBundle) {
        tags.push(this.selectedBundle);
      }

      const tagString = tags.join("+");
      const basePath = `/collections/${this.collectionHandle}`;
      const url = tagString ? `${basePath}/${tagString}` : basePath;
      const response = await fetch(url);
      const html = await response.text();
      const doc = new DOMParser().parseFromString(html, "text/html");
      const productContent = doc.querySelector(
        ".collection-content.bundle-content",
      );

      if (productContent && this.productGrid) {
        const newProductListWrap =
          productContent.querySelector(".product-list-wrap");
        const currentProductListWrap =
          this.productGrid.querySelector(".product-list-wrap");
        if (newProductListWrap && currentProductListWrap) {
          currentProductListWrap.innerHTML = newProductListWrap.innerHTML;
        }
        if (
          window.bundleManager &&
          typeof window.bundleManager.updateFreeTagVisibility === "function"
        ) {
          window.bundleManager.updateFreeTagVisibility();
        }
        if (
          window.bundleManager &&
          typeof window.bundleManager.updateBundleSlots === "function"
        ) {
          window.bundleManager.updateBundleSlots();
        }
      }
    } catch (error) {
      console.error("Product filter loading failed:", error);
    }
  }

  showLoadingState() {
    if (this.productGrid) {
      const productListWrap =
        this.productGrid.querySelector(".product-list-wrap");
      if (productListWrap) {
        productListWrap.innerHTML = `<div class="loading"></div>`;
      }
    }
  }

  updateSummary(left, right) {
    if (this.valueSpans.length >= 2) {
      this.valueSpans[0].textContent = left;
      this.valueSpans[1].textContent = right;
    }
  }

  updateRadioButtonsState() {
    const enabled = this.summaryWrapper?.classList.contains("is-visible");
    this.radios.forEach((radio) => {
      radio.disabled = !enabled;
      radio
        .closest(".product-personalization__bundle-card")
        ?.classList.toggle("is-disabled", !enabled);
    });
  }

  async updateCartAttribute(key, value) {
    try {
      await this.makeFetchRequest("/cart/update.js", {
        method: "POST",
        body: JSON.stringify({ attributes: { [key]: value } }),
      });
    } catch (error) {
      console.log(
        "🚀 ~ AjaxFormController ~ updateCartAttribute ~ error:",
        error,
      );
    }
  }

  initializeBundleFilter() {
    this.selectedBundle = this.selectedBundleElement?.value || null;
    this.selectedColor = this.selectedColorElement?.value || null;

    if (this.selectedBundle || this.selectedColor) {
      this.handleFilterChange();
    } else {
      this.toggleVisibility(this.productGrid, false);
    }
  }

  filterProductCardsByPrescription(leftEye, rightEye) {
    const productCards = document.querySelectorAll(
      ".collection-content.bundle-content .product-item",
    );
    let visibleCount = 0;
    productCards.forEach((card) => {
      try {
        const productData = card
          .querySelector("[data-bundle-product]")
          ?.getAttribute("data-bundle-product");
        if (!productData) return;
        const product = JSON.parse(productData);
        let leftAvailable = false;
        let rightAvailable = false;
        if (Array.isArray(product.variants)) {
          for (const variant of product.variants) {
            if (variant.title === leftEye) leftAvailable = true;
            if (variant.title === rightEye) rightAvailable = true;
          }
        }
        if (leftAvailable && rightAvailable) {
          card.classList.remove("hide");
          visibleCount++;
        } else {
          card.classList.add("hide");
        }
      } catch (e) {
        console.log("🚀 ~ AjaxFormController ~ productCards.forEach ~ e:", e);
      }
    });
    const noItemsMsg = document.querySelector(".no-items-available-message");
    if (noItemsMsg) {
      if (visibleCount === 0) {
        noItemsMsg.classList.remove("hide");
      } else {
        noItemsMsg.classList.add("hide");
      }
    }
  }
}

new AjaxFormController({
  formId: "prescription-form",
  leftEyeId: "left-eye",
  rightEyeId: "right-eye",
  summarySelector: ".product-personalization__summary-wrapper",
  radioSelector: 'input[name="bundle"]',
  productGridSelector: ".collection-content.bundle-content",
  collectionHandleSelector: "[data-collection-handle]",
});

class BundleManager {
  constructor() {
    this.BUNDLE_KEYS = {
      "period__1-day": "bundleProducts1Day",
      "period__3-month": "bundleProducts3Month",
    };
    this.BUNDLE_SIZE = 4;
    this.FREE_TAG_THRESHOLD = 3;
    this.productGridObserver = null;
    this.init();
  }
  init() {
    this.setupProductGridObserver();
    this.attachEventListeners();
    this.restoreQuantitiesFromStorage();
    this.initBundleSlotsUpdater();
    this.updateAddBundleButtonText();
    window.addEventListener(
      "storageUpdate",
      this.updateAddBundleButtonText.bind(this),
    );
    document.querySelectorAll('input[name="bundle"]').forEach((radio) => {
      radio.addEventListener(
        "change",
        this.updateAddBundleButtonText.bind(this),
      );
    });
  }

  setupProductGridObserver() {
    const productGrid = document.querySelector(
      ".collection-content.bundle-content",
    );

    if (!productGrid) {
      setTimeout(() => this.setupProductGridObserver(), 1000);
      return;
    }

    this.productGridObserver?.disconnect();

    const handleMutations = (mutations) => {
      const productAdded = mutations.some(
        (mutation) =>
          mutation.type === "childList" &&
          Array.from(mutation.addedNodes).some(
            (node) =>
              node.nodeType === Node.ELEMENT_NODE &&
              (node.querySelector("[data-product-id]") ||
                node.hasAttribute("data-product-id")),
          ),
      );

      if (productAdded) {
        this.restoreQuantitiesFromStorage();
      }
    };

    this.productGridObserver = new MutationObserver(handleMutations);

    this.productGridObserver.observe(productGrid, {
      childList: true,
      subtree: true,
    });

    if (productGrid.children.length) {
      this.restoreQuantitiesFromStorage();
    }
  }

  attachEventListeners() {
    document.addEventListener("click", (event) => {
      const button = event.target.closest(
        ".add-to-bundle-btn, .quantity-plus, .quantity-minus",
      );

      if (!button) return;

      if (button.classList.contains("add-to-bundle-btn")) {
        this.handleAddToBundle(button);
      } else if (button.classList.contains("quantity-plus")) {
        this.handleQuantityChange(button, 1);
      } else if (button.classList.contains("quantity-minus")) {
        this.handleQuantityChange(button, -1);
      }

      this.updateFreeTagVisibility();
    });
  }

  getCurrentBundleKey() {
    const selectedBundleRadio = document.querySelector(
      'input[name="bundle"]:checked',
    );
    const selectedBundle = selectedBundleRadio?.value;
    return (
      this.BUNDLE_KEYS[selectedBundle] || this.BUNDLE_KEYS["period__1-day"]
    );
  }

  getBundle(key = null) {
    const storageKey = key || this.getCurrentBundleKey();
    const initialBundle = new Array(this.BUNDLE_SIZE).fill(null);
    try {
      const storedBundle = JSON.parse(localStorage.getItem(storageKey));
      return Array.isArray(storedBundle) &&
        storedBundle.length === this.BUNDLE_SIZE
        ? storedBundle
        : initialBundle;
    } catch {
      return initialBundle;
    }
  }

  saveBundle(bundle, key = null) {
    const storageKey = key || this.getCurrentBundleKey();
    if (!storageKey) return;
    localStorage.setItem(storageKey, JSON.stringify(bundle));
    window.dispatchEvent(new Event("storageUpdate"));
    this.updateAddBundleButtonText();
  }

  getEyePrescriptions() {
    const summaryWrapper = document.querySelector(
      ".product-personalization__summary-wrapper",
    );
    if (!summaryWrapper) return { leftEye: null, rightEye: null };

    const valueSpans = summaryWrapper.querySelectorAll(
      ".product-personalization__value",
    );
    return {
      leftEye: valueSpans[0]?.textContent.trim() || null,
      rightEye: valueSpans[1]?.textContent.trim() || null,
    };
  }

  findVariantId(variantSelect, prescription) {
    if (!variantSelect || !prescription) return null;

    const matchingOption = Array.from(variantSelect.options).find(
      (option) => option.textContent.trim() === prescription,
    );
    return matchingOption?.value || null;
  }

  getMasterVariantId(variantSelect) {
    if (!variantSelect) return null;
    return variantSelect.options[0].value;
  }

  getVariantStock(variantSelect, variantId) {
    if (!variantSelect || !variantId) return 0;
    const option = Array.from(variantSelect.options).find(
      (opt) => opt.value === variantId,
    );
    const stock = option ? parseInt(option.dataset.inventory, 10) : 0;
    return stock;
  }

  handleAddToBundle(button) {
    const productCard = button.closest("[data-product-id]");
    if (!productCard) return;

    const { leftEye, rightEye } = this.getEyePrescriptions();
    const selectedBundle = this.getSelectedBundleType();

    if (!leftEye || !rightEye || !selectedBundle) return;

    const variantSelect = productCard.querySelector(
      'select[name="bundle_variant_id"]',
    );
    const storageKey = this.BUNDLE_KEYS[selectedBundle];
    const itemsAdded = this.addItemsToBundle(
      variantSelect,
      leftEye,
      rightEye,
      selectedBundle,
      storageKey,
    );

    if (itemsAdded > 0) {
      this.updateCardUI(productCard, itemsAdded);

      const bundleList = document.querySelector(
        ".bundle-selected-products .bundle-list",
      );
      const toggleButton = document.querySelector(
        ".bundle-selected-products .toggle-btn",
      );
      if (bundleList || toggleButton) {
        bundleList.classList.add("mobile-active");
        toggleButton.classList.add("active");
      }
    }
  }

  addItemsToBundle(variantSelect, leftEye, rightEye, bundleType, storageKey) {
    const bundle = this.getBundle(storageKey);

    if (bundleType === "period__1-day") {
      return this.addToDailyBundle(
        bundle,
        variantSelect,
        leftEye,
        rightEye,
        storageKey,
      );
    } else if (bundleType === "period__3-month") {
      return this.addToMonthlyBundle(
        bundle,
        variantSelect,
        leftEye,
        rightEye,
        storageKey,
      );
    }

    return 0;
  }

  addToDailyBundle(bundle, variantSelect, leftEye, rightEye, storageKey) {
    if (leftEye === rightEye) {
      const variantId = this.findVariantId(variantSelect, leftEye);
      if (!variantId) return 0;

      const emptySlotIndex = bundle.findIndex((slot) => slot === null);
      if (emptySlotIndex === -1) return 0;

      bundle[emptySlotIndex] = variantId;
      this.saveBundle(bundle, storageKey);
      return 1;
    } else {
      const leftVariantId = this.findVariantId(variantSelect, leftEye);
      const rightVariantId = this.findVariantId(variantSelect, rightEye);

      if (!leftVariantId || !rightVariantId) return 0;

      const emptySlots = this.getEmptySlotIndices(bundle);
      if (emptySlots.length < 2) return 0;

      bundle[emptySlots[0]] = { left: leftVariantId };
      bundle[emptySlots[1]] = { right: rightVariantId };
      this.saveBundle(bundle, storageKey);
      return 2;
    }
  }

  addToMonthlyBundle(bundle, variantSelect, leftEye, rightEye, storageKey) {
    const leftVariantId = this.findVariantId(variantSelect, leftEye);
    const rightVariantId = this.findVariantId(variantSelect, rightEye);
    const masterVariantId = this.getMasterVariantId(variantSelect);

    if (!leftVariantId || !rightVariantId) return 0;

    const emptySlotIndex = bundle.findIndex((slot) => slot === null);
    if (emptySlotIndex === -1) return 0;

    bundle[emptySlotIndex] = {
      left: leftVariantId,
      right: rightVariantId,
      master: masterVariantId || null,
    };
    this.saveBundle(bundle, storageKey);
    return 1;
  }

  handleQuantityChange(button, change) {
    const productCard = button.closest("[data-product-id]");
    if (!productCard) return;

    const { leftEye, rightEye } = this.getEyePrescriptions();
    if (!leftEye || !rightEye) return;

    const variantSelect = productCard.querySelector(
      'select[name="bundle_variant_id"]',
    );
    const quantityValue = productCard.querySelector(".quantity-value");
    const storageKey = this.getCurrentBundleKey();
    const bundle = this.getBundle(storageKey);

    let currentQuantity = parseInt(quantityValue.textContent, 10);
    const newQuantity = this.updateBundleQuantity(
      bundle,
      variantSelect,
      leftEye,
      rightEye,
      change,
      storageKey,
    );

    this.shiftAllItemsLeft(bundle);

    if (newQuantity !== currentQuantity) {
      this.saveBundle(bundle, storageKey);
      quantityValue.textContent = newQuantity;
      this.toggleCardButtons(productCard, newQuantity);
    }

    const bundleList = document.querySelector(
      ".bundle-selected-products .bundle-list",
    );
    const toggleButton = document.querySelector(
      ".bundle-selected-products .toggle-btn",
    );
    if (bundleList || toggleButton) {
      const filledCount = bundle.filter((slot) => slot !== null).length;
      if (filledCount > 0) {
        bundleList.classList.add("mobile-active");
        toggleButton.classList.add("active");
      } else {
        bundleList.classList.remove("mobile-active");
        toggleButton.classList.remove("active");
      }
    }
  }

  updateBundleQuantity(
    bundle,
    variantSelect,
    leftEye,
    rightEye,
    change,
    storageKey,
  ) {
    const isDailyBundle = storageKey === this.BUNDLE_KEYS["period__1-day"];

    if (isDailyBundle) {
      return this.updateDailyBundleQuantity(
        bundle,
        variantSelect,
        leftEye,
        rightEye,
        change,
      );
    } else {
      return this.updateMonthlyBundleQuantity(
        bundle,
        variantSelect,
        leftEye,
        rightEye,
        change,
      );
    }
  }

  updateDailyBundleQuantity(bundle, variantSelect, leftEye, rightEye, change) {
    const currentQuantity = this.getCurrentQuantityInBundle(
      bundle,
      variantSelect,
      leftEye,
      rightEye,
      true,
    );

    if (change > 0) {
      return this.increaseDailyBundleQuantity(
        bundle,
        variantSelect,
        leftEye,
        rightEye,
        currentQuantity,
      );
    } else {
      return this.decreaseDailyBundleQuantity(
        bundle,
        variantSelect,
        leftEye,
        rightEye,
        currentQuantity,
      );
    }
  }

  updateMonthlyBundleQuantity(
    bundle,
    variantSelect,
    leftEye,
    rightEye,
    change,
  ) {
    const currentQuantity = this.getCurrentQuantityInBundle(
      bundle,
      variantSelect,
      leftEye,
      rightEye,
      false,
    );

    if (change > 0) {
      return this.increaseMonthlyBundleQuantity(
        bundle,
        variantSelect,
        leftEye,
        rightEye,
        currentQuantity,
      );
    } else {
      return this.decreaseMonthlyBundleQuantity(
        bundle,
        variantSelect,
        leftEye,
        rightEye,
        currentQuantity,
      );
    }
  }

  increaseDailyBundleQuantity(
    bundle,
    variantSelect,
    leftEye,
    rightEye,
    currentQuantity,
  ) {
    const leftVariantId = this.findVariantId(variantSelect, leftEye);
    const rightVariantId = this.findVariantId(variantSelect, rightEye);

    const isSamePrescription = leftEye === rightEye;
    const emptySlots = this.getEmptySlotIndices(bundle);
    const leftStock = this.getVariantStock(variantSelect, leftVariantId);
    const rightStock = this.getVariantStock(variantSelect, rightVariantId);

    const usedLeft = bundle.filter(
      (item) => item === leftVariantId || item?.left === leftVariantId,
    ).length;
    const usedRight = bundle.filter(
      (item) => item === rightVariantId || item?.right === rightVariantId,
    ).length;

    const hasLeftStock = leftStock > usedLeft;
    const hasRightStock = rightStock > usedRight;

    if (hasLeftStock && hasRightStock) {
      if (isSamePrescription) {
        const emptySlotIndex = bundle.findIndex((slot) => slot === null);
        bundle[emptySlotIndex] = leftVariantId;
        return currentQuantity + 1;
      } else {
        if (emptySlots.length >= 2) {
          bundle[emptySlots[0]] = { left: leftVariantId };
          bundle[emptySlots[1]] = { right: rightVariantId };
          return currentQuantity + 2;
        }
      }
    }

    const productCard = variantSelect.closest(".product-card--list");
    const productDataElement = productCard?.querySelector(
      "[data-bundle-product]",
    );

    const productTitle = JSON.parse(
      productDataElement.dataset.bundleProduct,
    )?.title;

    let outOfStockDetails = [];
    if (!hasLeftStock) outOfStockDetails.push(`Left: ${leftEye}`);
    if (!hasRightStock) outOfStockDetails.push(`Right: ${rightEye}`);

    const variantLabel = `${outOfStockDetails.join(" & ")} — The maximum quantity of this item is already in your cart.`;

    this.showStockPopup(productTitle, variantLabel);

    return currentQuantity;
  }

  decreaseDailyBundleQuantity(
    bundle,
    variantSelect,
    leftEye,
    rightEye,
    currentQuantity,
  ) {
    if (leftEye === rightEye) {
      const variantId = this.findVariantId(variantSelect, leftEye);
      const lastIndex = bundle.lastIndexOf(variantId);
      if (lastIndex !== -1) {
        bundle[lastIndex] = null;
        return currentQuantity - 1;
      }
    } else {
      const removed = this.removeLastEyePairFromBundle(
        bundle,
        variantSelect,
        leftEye,
        rightEye,
      );
      return removed ? currentQuantity - 2 : currentQuantity;
    }
    return currentQuantity;
  }

  increaseMonthlyBundleQuantity(
    bundle,
    variantSelect,
    leftEye,
    rightEye,
    currentQuantity,
  ) {
    const leftVariantId = this.findVariantId(variantSelect, leftEye);
    const rightVariantId = this.findVariantId(variantSelect, rightEye);
    const masterVariantId = this.getMasterVariantId(variantSelect);
    const emptySlotIndex = bundle.findIndex((slot) => slot === null);

    if (emptySlotIndex === -1 || !leftVariantId || !rightVariantId) {
      return currentQuantity;
    }

    const leftStock = this.getVariantStock(variantSelect, leftVariantId);
    const rightStock = this.getVariantStock(variantSelect, rightVariantId);

    const usedLeft = bundle.filter(
      (bundleItem) => bundleItem?.left === leftVariantId,
    ).length;
    const usedRight = bundle.filter(
      (bundleItem) => bundleItem?.right === rightVariantId,
    ).length;

    if (leftStock > usedLeft && rightStock > usedRight) {
      bundle[emptySlotIndex] = {
        left: leftVariantId,
        right: rightVariantId,
        master: masterVariantId || null,
      };
      return currentQuantity + 1;
    }

    const productCard = variantSelect.closest(".product-card--list");
    const productDataElement = productCard.querySelector(
      "[data-bundle-product]",
    );
    const productTitle = JSON.parse(
      productDataElement.dataset.bundleProduct,
    )?.title;

    let outOfStockDetails = [];
    if (leftStock <= usedLeft) outOfStockDetails.push(`Left: ${leftEye}`);
    if (rightStock <= usedRight) outOfStockDetails.push(`Right: ${rightEye}`);

    const variantLabel = `${outOfStockDetails.join(" & ")} — The maximum quantity of this item is already in your cart.`;

    this.showStockPopup(productTitle, variantLabel);

    return currentQuantity;
  }

  decreaseMonthlyBundleQuantity(
    bundle,
    variantSelect,
    leftEye,
    rightEye,
    currentQuantity,
  ) {
    const leftVariantId = this.findVariantId(variantSelect, leftEye);
    const rightVariantId = this.findVariantId(variantSelect, rightEye);

    for (let i = bundle.length - 1; i >= 0; i--) {
      const slot = bundle[i];
      if (slot?.left === leftVariantId && slot?.right === rightVariantId) {
        bundle[i] = null;
        return currentQuantity - 1;
      }
    }
    return currentQuantity;
  }

  getSelectedBundleType() {
    const selectedBundleRadio = document.querySelector(
      'input[name="bundle"]:checked',
    );
    return selectedBundleRadio?.value || null;
  }

  getEmptySlotIndices(bundle) {
    return bundle
      .map((slot, index) => (slot === null ? index : -1))
      .filter((index) => index !== -1);
  }

  getCurrentQuantityInBundle(
    bundle,
    variantSelect,
    leftEye,
    rightEye,
    isDailyBundle,
  ) {
    if (isDailyBundle) {
      if (leftEye === rightEye) {
        const variantId = this.findVariantId(variantSelect, leftEye);
        return bundle.filter((slot) => slot === variantId).length;
      } else {
        const leftVariantId = this.findVariantId(variantSelect, leftEye);
        const rightVariantId = this.findVariantId(variantSelect, rightEye);
        let pairs = 0;
        for (let i = 0; i < bundle.length - 1; i++) {
          if (
            typeof bundle[i] === "object" &&
            typeof bundle[i + 1] === "object" &&
            bundle[i]?.left === leftVariantId &&
            bundle[i + 1]?.right === rightVariantId
          ) {
            pairs++;
            i++;
          } else if (
            typeof bundle[i] === "object" &&
            typeof bundle[i + 1] === "object" &&
            bundle[i]?.right === rightVariantId &&
            bundle[i + 1]?.left === leftVariantId
          ) {
            pairs++;
            i++;
          }
        }
        return pairs * 2;
      }
    } else {
      const leftVariantId = this.findVariantId(variantSelect, leftEye);
      const rightVariantId = this.findVariantId(variantSelect, rightEye);
      return bundle.filter(
        (slot) =>
          slot?.left === leftVariantId && slot?.right === rightVariantId,
      ).length;
    }
  }

  removeLastEyePairFromBundle(bundle, variantSelect, leftEye, rightEye) {
    const leftVariantId = this.findVariantId(variantSelect, leftEye);
    const rightVariantId = this.findVariantId(variantSelect, rightEye);
    for (let i = bundle.length - 1; i > 0; i--) {
      if (
        typeof bundle[i] === "object" &&
        typeof bundle[i - 1] === "object" &&
        bundle[i]?.right === rightVariantId &&
        bundle[i - 1]?.left === leftVariantId
      ) {
        bundle[i - 1] = null;
        bundle[i] = null;
        return true;
      } else if (
        typeof bundle[i] === "object" &&
        typeof bundle[i - 1] === "object" &&
        bundle[i]?.left === leftVariantId &&
        bundle[i - 1]?.right === rightVariantId
      ) {
        bundle[i - 1] = null;
        bundle[i] = null;
        return true;
      }
    }
    return false;
  }

  updateAllBundleActionButtons() {
    const storageKey = this.getCurrentBundleKey();
    const bundle = this.getBundle(storageKey);
    const isFull = bundle.every((slot) => slot !== null);
    document.querySelectorAll(".quantity-plus").forEach((btn) => {
      btn.disabled = isFull;
    });
    document.querySelectorAll(".add-to-bundle-btn").forEach((btn) => {
      if (!btn.classList.contains("sold-out")) {
        btn.disabled = isFull;
      }
    });
  }

  updateCardUI(productCard, quantity) {
    const addToBundleBtn = productCard.querySelector(".add-to-bundle-btn");
    const quantitySelector = productCard.querySelector(".quantity-selector");
    const quantityValue = productCard.querySelector(".quantity-value");

    addToBundleBtn?.classList.add("hide");
    quantitySelector?.classList.remove("hide");
    if (quantityValue) quantityValue.textContent = quantity;

    this.updateAllBundleActionButtons();
  }

  toggleCardButtons(productCard, quantity) {
    const addToBundleBtn = productCard.querySelector(".add-to-bundle-btn");
    const quantitySelector = productCard.querySelector(".quantity-selector");
    const quantityPlusBtn = productCard.querySelector(".quantity-plus");

    if (quantity === 0) {
      addToBundleBtn?.classList.remove("hide");
      quantitySelector?.classList.add("hide");
    }

    this.updateAllBundleActionButtons();
  }

  updateFreeTagVisibility() {
    const currentBundleKey = this.getCurrentBundleKey();
    const currentBundle = this.getBundle(currentBundleKey);
    const filledSlots = currentBundle.filter((slot) => slot !== null).length;
    const shouldShow = filledSlots === this.FREE_TAG_THRESHOLD;
    this.toggleFreeTags(shouldShow);
  }

  toggleFreeTags(show) {
    const productCards = document.querySelectorAll("[data-product-id]");
    productCards.forEach((card) => {
      const freeTag = card.querySelector(".free-tag");
      const priceListing = card.querySelector(".price--listing");
      const addBtn = card.querySelector(".add-to-bundle-btn");
      const isSoldOut = addBtn && addBtn.classList.contains("sold-out");
      if (freeTag) {
        freeTag.classList.toggle("hide", !show || isSoldOut);
        if (priceListing) {
          priceListing.classList.toggle("hide", show && !isSoldOut);
        }
      }
    });
  }

  restoreQuantitiesFromStorage() {
    const productCards = document.querySelectorAll("[data-product-id]");

    const bundleKey = this.getCurrentBundleKey();
    const bundle = this.getBundle(bundleKey);

    productCards.forEach((productCard) => {
      const variantSelect = productCard.querySelector(
        'select[name="bundle_variant_id"]',
      );
      const quantityValue = productCard.querySelector(".quantity-value");
      const addToBundleBtn = productCard.querySelector(".add-to-bundle-btn");
      const quantitySelector = productCard.querySelector(".quantity-selector");
      const quantityPlusBtn = productCard.querySelector(".quantity-plus");

      const { leftEye, rightEye } = this.getEyePrescriptions();
      if (!leftEye || !rightEye) {
        addToBundleBtn?.classList.remove("hide");
        quantitySelector?.classList.add("hide");
        if (quantityValue) quantityValue.textContent = 0;
        if (quantityPlusBtn) quantityPlusBtn.disabled = false;
        return;
      }

      const isDailyBundle = bundleKey === this.BUNDLE_KEYS["period__1-day"];
      const quantity = this.getCurrentQuantityInBundle(
        bundle,
        variantSelect,
        leftEye,
        rightEye,
        isDailyBundle,
      );

      if (quantity > 0) {
        addToBundleBtn?.classList.add("hide");
        quantitySelector?.classList.remove("hide");
        if (quantityValue) quantityValue.textContent = quantity;
      } else {
        addToBundleBtn?.classList.remove("hide");
        quantitySelector?.classList.add("hide");
        if (quantityValue) quantityValue.textContent = 0;
      }
      const isFull = bundle.every((slot) => slot !== null);
      if (quantityPlusBtn) quantityPlusBtn.disabled = isFull;
    });
    this.updateAllBundleActionButtons();
    this.updateAddBundleButtonText();
  }

  cleanup() {
    if (this.productGridObserver) {
      this.productGridObserver.disconnect();
      this.productGridObserver = null;
    }
  }

  initBundleSlotsUpdater() {
    const bundleListSelector = ".bundle-selected-products .bundle-list";
    const getVariantMap = () => {
      const el = document.getElementById("variant-to-product-map");
      return el ? JSON.parse(el.textContent) : {};
    };

    const getPrescriptionValues = () => {
      const summaryWrapper = document.querySelector(
        ".product-personalization__summary-wrapper",
      );
      const spans = summaryWrapper
        ? summaryWrapper.querySelectorAll(".product-personalization__value")
        : [];
      return {
        left: spans[0]?.textContent.trim() || "",
        right: spans[1]?.textContent.trim() || "",
      };
    };

    const clearAllSlots = (bundleList) => {
      for (let i = 1; i <= this.BUNDLE_SIZE; i++) {
        const slot = bundleList.querySelector(`.item-${i}`);
        if (slot) {
          slot.innerHTML = "";
          slot.classList.remove("added", "free");
        }
      }
    };

    const renderSlot = (slot, productInfo, prescriptionValue, index) => {
      const isThreeMonthWithBothEyes =
        prescriptionValue.includes("(L)") && prescriptionValue.includes("(R)");

      let itemInfoContent = "";
      if (isThreeMonthWithBothEyes) {
        const [leftEye, rightEye] = prescriptionValue.split(" | ");
        itemInfoContent = `
          <span class="left-eye">${leftEye.replace(/\s*\([^)]*\)/g, "")}</span>
          <span class="right-eye">${rightEye.replace(
            /\s*\([^)]*\)/g,
            "",
          )}</span>
        `;
      } else {
        itemInfoContent = `<span>${prescriptionValue.replace(
          /\s*\([^)]*\)/g,
          "",
        )}</span>`;
      }

      slot.innerHTML = `
        <div class="added-item">
          <div class="item-content">
            <a href="#" class="remove-item" data-slot-index="${index + 1}"></a>
            <div class="item-image">
              <img src="${productInfo.productImage}" alt="${
                productInfo.productTitle
              }">
            </div>
            <div class="item-info ${isThreeMonthWithBothEyes ? "half" : ""}">
              ${itemInfoContent}
            </div>
          </div>
          <div class="item-title">${productInfo.productTitle.replace(
            /\s*\([^)]*\)/g,
            "",
          )}</div>
        </div>`;
      slot.classList.add("added");
      if (index + 1 === this.BUNDLE_SIZE) {
        slot.classList.remove("free");
      }
    };

    const updateBundleSlots = () => {
      const storageKey = this.getCurrentBundleKey();
      const bundleList = document.querySelector(bundleListSelector);
      if (!bundleList) return;

      const variantMap = getVariantMap();
      const { left, right } = getPrescriptionValues();
      const bundleItems = JSON.parse(localStorage.getItem(storageKey)) || [];

      clearAllSlots(bundleList);

      let total = 0;
      let lastPrice = 0;
      let filledCount = 0;
      const isThreeMonth = storageKey === this.BUNDLE_KEYS["period__3-month"];
      const isOneDay = storageKey === this.BUNDLE_KEYS["period__1-day"];
      bundleItems.forEach((item, index) => {
        const slot = bundleList.querySelector(`.item-${index + 1}`);
        if (!slot) return;

        let variantId = null;
        let prescriptionValue = "";
        let price = 0;

        if (
          isThreeMonth &&
          typeof item === "object" &&
          item !== null &&
          item.left &&
          item.right
        ) {
          const leftInfo = variantMap[item.left];
          const rightInfo = variantMap[item.right];
          const leftPrice = leftInfo
            ? parseFloat(
                leftInfo.variantPrice.toString().replace(/[^\d.]/g, ""),
              )
            : 0;
          const rightPrice = rightInfo
            ? parseFloat(
                rightInfo.variantPrice.toString().replace(/[^\d.]/g, ""),
              )
            : 0;
          price = leftPrice + rightPrice;
          prescriptionValue = `${left} (L) | ${right} (R)`;
          renderSlot(slot, leftInfo || rightInfo, prescriptionValue, index);
          total += price;
          lastPrice = price;
          filledCount++;
          return;
        }

        if (typeof item === "object" && item !== null) {
          if (item.left) {
            variantId = item.left;
            prescriptionValue = `${left} (L)`;
          } else if (item.right) {
            variantId = item.right;
            prescriptionValue = `${right} (R)`;
          }
        } else {
          variantId = item;
          prescriptionValue = left;
        }

        const productInfo = variantMap[variantId];
        if (productInfo) {
          price = parseFloat(
            productInfo.variantPrice.toString().replace(/[^\d.]/g, ""),
          );
          renderSlot(slot, productInfo, prescriptionValue, index);
          total += price;
          lastPrice = price;
          filledCount++;
        } else {
          slot.innerHTML = "";
          slot.classList.remove("added");
        }
      });

      if (filledCount === this.BUNDLE_SIZE) {
        total -= lastPrice;
      }

      const priceEl = document.querySelector(".bundle-price");
      if (priceEl) {
        const getCurrencySymbol = () => {
          const initialVariant = Object.values(variantMap).find(
            (variant) => variant?.variantPrice,
          );
          return initialVariant?.variantPrice?.match(/^[^\d]*/)?.[0] || "";
        };

        const formatPrice = (price) =>
          getCurrencySymbol() + price.toLocaleString("en-US");

        if (filledCount === this.BUNDLE_SIZE) {
          const originalTotal = total + lastPrice;
          const discountedTotal = total;
          priceEl.innerHTML = `
            <span class="bundle-discounted-price">${formatPrice(
              discountedTotal,
            )}</span>
            <span class="bundle-original-price">${formatPrice(
              originalTotal,
            )}</span>
          `;
          const lastSlot = document.querySelector(
            `${bundleListSelector} .item-${this.BUNDLE_SIZE}`,
          );
          if (lastSlot) {
            lastSlot.classList.add("is-free");
          }
        } else {
          priceEl.textContent = formatPrice(total);
        }
      }

      const lastSlot = bundleList.querySelector(`.item-${this.BUNDLE_SIZE}`);
      if (lastSlot && !lastSlot.classList.contains("added")) {
        lastSlot.classList.remove("is-free");
      }

      const isDifferentPrescription = left !== right;
      if (isOneDay && isDifferentPrescription && filledCount < 4) {
        const lastSlot = bundleList.querySelector(`.item-${this.BUNDLE_SIZE}`);
        if (lastSlot) {
          lastSlot.classList.remove("is-free");
        }
      }

      if (bundleItems.filter(Boolean).length < this.BUNDLE_SIZE) {
        const lastSlot = bundleList.querySelector(`.item-${this.BUNDLE_SIZE}`);
        if (lastSlot && !lastSlot.classList.contains("added")) {
          lastSlot.innerHTML = `<span class="free-text">FREE</span>`;
          lastSlot.classList.add("free");
        }
      }

      bundleList.querySelectorAll(".remove-item").forEach((button) => {
        button.addEventListener("click", (e) => {
          e.preventDefault();
          const slotIndex = parseInt(e.currentTarget.dataset.slotIndex, 10);
          this.removeFromBundle(slotIndex);
        });
      });
    };

    this.updateBundleSlots = updateBundleSlots;

    const observer = new MutationObserver((mutations, obs) => {
      const bundleList = document.querySelector(bundleListSelector);
      if (bundleList) {
        updateBundleSlots();
        window.addEventListener("storageUpdate", updateBundleSlots);
        document.querySelectorAll('input[name="bundle"]').forEach((radio) => {
          radio.addEventListener("change", updateBundleSlots);
        });
        obs.disconnect();
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  removeFromBundle(slotIndex) {
    const storageKey = this.getCurrentBundleKey();
    if (!storageKey) return;

    const bundle = this.getBundle(storageKey);
    const idx = slotIndex - 1;
    if (idx < 0 || idx >= bundle.length) return;

    const item = bundle[idx];
    if (item === null) return;

    const variantMap = (() => {
      const el = document.getElementById("variant-to-product-map");
      return el ? JSON.parse(el.textContent) : {};
    })();

    const getVariantInfo = (item) => {
      if (typeof item === "object" && item !== null) {
        if (item.left) return { variantId: item.left, side: "left" };
        if (item.right) return { variantId: item.right, side: "right" };
      }
      return { variantId: item, side: null };
    };

    const { variantId, side } = getVariantInfo(item);
    const productId = variantMap[variantId]?.productId;

    const isDaily = storageKey === this.BUNDLE_KEYS["period__1-day"];

    if (isDaily && side) {
      const pairIdx = idx % 2 === 0 ? idx + 1 : idx - 1;
      if (pairIdx < bundle.length) {
        bundle[pairIdx] = null;
      }
    }

    bundle[idx] = null;
    this.shiftAllItemsLeft(bundle);
    this.saveBundle(bundle, storageKey);

    if (productId) {
      const productCard = document.querySelector(
        `[data-product-id="${productId}"]`,
      );
      if (productCard) {
        const variantSelect = productCard.querySelector(
          'select[name="bundle_variant_id"]',
        );
        const quantityValue = productCard.querySelector(".quantity-value");
        const addToBundleBtn = productCard.querySelector(".add-to-bundle-btn");
        const quantitySelector =
          productCard.querySelector(".quantity-selector");
        const quantityPlusBtn = productCard.querySelector(".quantity-plus");

        const { leftEye, rightEye } = this.getEyePrescriptions();
        const isFull = bundle.every((slot) => slot !== null);

        const quantity = this.getCurrentQuantityInBundle(
          bundle,
          variantSelect,
          leftEye,
          rightEye,
          isDaily,
        );

        if (quantityValue) quantityValue.textContent = quantity;

        if (quantity === 0) {
          addToBundleBtn?.classList.remove("hide");
          quantitySelector?.classList.add("hide");
        }

        if (quantityPlusBtn) {
          quantityPlusBtn.disabled = isFull;
        }
      }
    }

    // const bundleList = document.querySelector(
    //   ".bundle-selected-products .bundle-list"
    // );
    // const toggleButton = document.querySelector(
    //   ".bundle-selected-products .toggle-btn"
    // );
    // if (bundleList || toggleButton) {
    //   bundleList.classList.remove("mobile-active");
    //   toggleButton.classList.remove("active");
    // }

    this.updateAllBundleActionButtons();
    this.updateFreeTagVisibility();
    this.updateAddBundleButtonText();
    window.dispatchEvent(new Event("storageUpdate"));
  }

  shiftAllItemsLeft(bundle) {
    const length = bundle.length;
    let index = 0;

    for (let i = 0; i < length; i++) {
      if (bundle[i] !== null) {
        bundle[index++] = bundle[i];
      }
    }

    while (index < length) {
      bundle[index++] = null;
    }
  }

  updateAddBundleButtonText() {
    const btn = document.querySelector("#add-bundle-to-cart-btn");
    const btnText = btn?.querySelector(".btn-text");
    if (!btnText || !btn) return;
    const storageKey = this.getCurrentBundleKey();
    const bundle = this.getBundle(storageKey);
    const emptySlots =
      this.BUNDLE_SIZE - bundle.filter((x) => x !== null).length;
    if (emptySlots === 0) {
      btnText.textContent = "Add bundle to cart";
      btn.classList.remove("disabled");
    } else {
      btnText.textContent = `Add ${emptySlots} more`;
      btn.classList.add("disabled");
    }
  }

  showStockPopup(productTitle, variantLabel) {
    const popup = document.querySelector(".stock-popup");
    if (!popup) return;

    popup.querySelector(".stock-popup__product-title").textContent =
      productTitle;
    popup.querySelector(".stock-popup__variant-label").textContent =
      variantLabel;

    if (!popup.dataset.initialized) {
      popup.addEventListener("click", (e) => {
        const isCloseAction =
          e.target.closest(".overlay") || e.target.closest(".cross-icon");
        if (isCloseAction) {
          e.preventDefault();
          popup.classList.add("hide");
          document.body.style.overflow = "auto";
        }
      });
      popup.dataset.initialized = "true";
    }

    popup.classList.remove("hide");
    document.body.style.overflow = "hidden";
  }
}

window.bundleManager = new BundleManager();

const BUNDLE_KEYS = ["bundleProducts1Day", "bundleProducts3Month"];

// Adding products to the cart
const getBundleItems = () => {
  const items = [];
  const selectedBundle = document.querySelector(
    'input[name="bundle"]:checked',
  )?.value;
  let bundleKey = null;
  if (selectedBundle === "period__1-day") {
    bundleKey = "bundleProducts1Day";
  } else if (selectedBundle === "period__3-month") {
    bundleKey = "bundleProducts3Month";
  }

  if (!bundleKey) return items;

  const bundle = JSON.parse(localStorage.getItem(bundleKey) || "[]");
  if (bundleKey === "bundleProducts3Month") {
    bundle.forEach((slot) => {
      if (!slot) return;
      const masterId = slot.master;
      const properties = {
        _left_variant_id: slot.left,
        _right_variant_id: slot.right,
        _bundle_tag: "Period__3-Month",
        _is_bundle_product: true,
      };
      if (masterId) {
        items.push({
          id: masterId,
          quantity: 1,
          properties,
        });
      }
    });
  } else {
    // 1-day bundle
    bundle.forEach((slot) => {
      if (slot && typeof slot === "object") {
        if (slot.left)
          items.push({
            id: slot.left,
            quantity: 1,
            properties: {
              _bundle_tag: "Period__1-Day",
              _is_bundle_product: true,
            },
          });
        if (slot.right)
          items.push({
            id: slot.right,
            quantity: 1,
            properties: {
              _bundle_tag: "Period__1-Day",
              _is_bundle_product: true,
            },
          });
      } else if (slot) {
        items.push({
          id: slot,
          quantity: 1,
          properties: {
            _bundle_tag: "Period__1-Day",
            _is_bundle_product: true,
          },
        });
      }
    });
  }
  return items;
};

const mergeItems = (items) => {
  const merged = {};

  for (const item of items) {
    merged[item.id] = merged[item.id]
      ? { ...item, quantity: merged[item.id].quantity + item.quantity }
      : { ...item };
  }

  return Object.values(merged);
};

const addToCart = async (items, cleanupContext) => {
  try {
    const response = await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ items }),
    });
    if (response.ok) {
      await handleCartSuccess(cleanupContext);
      localStorage.removeItem("bundleProducts1Day");
      localStorage.removeItem("bundleProducts3Month");
      window.dispatchEvent(new Event("storageUpdate"));
      if (
        window.bundleManager &&
        typeof window.bundleManager.restoreQuantitiesFromStorage === "function"
      ) {
        window.bundleManager.restoreQuantitiesFromStorage();
      }
    } else if (cleanupContext) {
      cleanupContext.button.classList.remove("is-loading");
    }
  } catch (err) {
    console.error("🚀 ~ Cart Error:", err);
    if (cleanupContext) {
      cleanupContext.button.classList.remove("is-loading");
    }
  }
};

const handleCartSuccess = (cleanupContext) => {
  document.dispatchEvent(new CustomEvent("productAddedToCart"));
  if (window.carts && window.carts.length) {
    return Promise.all(
      window.carts.map((cart) => {
        return cart.onCartUpdated();
      }),
    ).then(() => {
      document.querySelector(".header__icons .header__icon--cart")?.click();
      if (cleanupContext) {
        cleanupContext.button.classList.remove("is-loading");
      }
    });
  } else {
    document.querySelector(".header__icons .header__icon--cart")?.click();
    if (cleanupContext) {
      cleanupContext.button.classList.remove("is-loading");
    }
    return Promise.resolve();
  }
};

document.addEventListener("click", async (e) => {
  const button = e.target.closest("#add-bundle-to-cart-btn");
  if (!button) return;
  if (button.classList.contains("disabled")) return;
  button.classList.add("is-loading");

  const items = getBundleItems();
  if (!items.length) {
    button.classList.remove("is-loading");
    return;
  }
  const mergedItems = mergeItems(items);
  await addToCart(mergedItems, { button });
});

// Bundle popup
const handleBundlePopup = () => {
  const bundlePopup = document.querySelector(".bundle-popup");
  if (!bundlePopup) return;

  const body = document.body;

  const selectors = {
    popupTitle: ".popup-wrapper .text-container .text-wrap .product-title",
    preText: ".popup-wrapper .text-container .text-wrap .pre-text",
    description: ".popup-wrapper .text-container .text-wrap .description",
    addToBundleBtn:
      ".popup-wrapper .text-container .bundle-div .add-to-bundle-btn",
  };

  const getElement = (selector) => bundlePopup.querySelector(selector);

  const updatePopupUI = (qty, addBtn, quantitySelector, quantityValue) => {
    quantityValue.textContent = qty;
    quantitySelector.classList.toggle("hide", qty === 0);
    addBtn.classList.toggle("hide", qty > 0);
  };

  const syncButtonState = (popupBtn, productCard) => {
    const mainAddBtn = productCard.querySelector(".add-to-bundle-btn");
    if (mainAddBtn) {
      popupBtn.disabled = mainAddBtn.disabled;
      popupBtn.classList.toggle("disabled", mainAddBtn.disabled);
      popupBtn.classList.toggle(
        "sold-out",
        mainAddBtn.classList.contains("sold-out"),
      );
      popupBtn.textContent = mainAddBtn.textContent;
    }
  };

  const initMediaSlider = (product, container) => {
    const mediaSlider = container.querySelector(".media-slider");
    if (!mediaSlider || !Array.isArray(product.media)) return;

    const imageMedia = product.media.filter((m) => m.media_type === "image");
    if (!imageMedia.length) return;

    if ($(mediaSlider).hasClass("slick-initialized")) {
      $(mediaSlider).slick("unslick");
    }

    mediaSlider.innerHTML = renderImageSlider(imageMedia, product.title);

    $(mediaSlider).slick({
      arrows: true,
      dots: true,
      infinite: false,
      responsive: [
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1.2,
            dots: false,
          },
        },
      ],
    });
  };

  function resizeShopifyImage(url, size) {
    return url.replace(/(\.(jpg|jpeg|png|webp|gif))(?!.*\1)/i, `_${size}$1`);
  }

  const renderImageSlider = (images, fallbackAlt) => {
    return images
      .map((media) => {
        const rawImgSrc = media?.preview_image?.src || media?.src || "";
        const imgSrc = resizeShopifyImage(rawImgSrc, "480x");
        const alt = media?.alt || fallbackAlt || "";
        return `<div class="img-wrapper"><img src="${imgSrc}" alt="${alt}" loading="lazy" /></div>`;
      })
      .join("");
  };

  const setPopupContent = (productData, subTitle, infoDescription) => {
    const product = JSON.parse(productData);
    getElement(selectors.popupTitle).textContent = product.title || "";
    getElement(selectors.preText).textContent = subTitle || "";
    getElement(selectors.description).textContent = infoDescription || "";
    bundlePopup.dataset.bundleProduct = productData;
    initMediaSlider(product, bundlePopup);

    const addBtn = getElement(selectors.addToBundleBtn);
    const quantitySelector = bundlePopup.querySelector(".quantity-selector");
    const quantityValue = bundlePopup.querySelector(".quantity-value");
    const minusBtn = bundlePopup.querySelector(".quantity-minus");
    const plusBtn = bundlePopup.querySelector(".quantity-plus");

    const productId = product.id;
    const productCard = document.querySelector(
      `[data-product-id='${productId}']`,
    );
    let mainQuantity = 0;

    if (productCard) {
      const quantityElement = productCard.querySelector(".quantity-value");
      mainQuantity = parseInt(quantityElement?.textContent, 10) || 0;
    }

    updatePopupUI(mainQuantity, addBtn, quantitySelector, quantityValue);
    syncButtonState(addBtn, productCard);

    const handleQuantityClick = (change) => {
      if (!productCard) return;
      const btnSelector = change === 1 ? ".quantity-plus" : ".quantity-minus";
      const button = productCard.querySelector(btnSelector);
      window.bundleManager.handleQuantityChange(button, change);
      const updatedQty =
        parseInt(
          productCard.querySelector(".quantity-value")?.textContent,
          10,
        ) || 0;
      updatePopupUI(updatedQty, addBtn, quantitySelector, quantityValue);
      syncButtonState(addBtn, productCard);
    };

    if (minusBtn && plusBtn) {
      minusBtn.onclick = (e) => {
        e.preventDefault();
        handleQuantityClick(-1);
      };
      plusBtn.onclick = (e) => {
        e.preventDefault();
        handleQuantityClick(1);
      };
    }
  };

  const openPopup = (productData, subTitle, infoDescription) => {
    if (!productData) return;
    bundlePopup.style.display = "block";
    body.style.overflow = "hidden";
    setPopupContent(productData, subTitle, infoDescription);
  };

  const closePopup = () => {
    bundlePopup.style.display = "none";
    body.style.overflow = "auto";
  };

  const handlePopupAddToBundle = () => {
    const productData = bundlePopup.dataset.bundleProduct;
    if (!productData) return;

    let productId = JSON.parse(productData).id;
    if (!productId) return;

    const productCard = document.querySelector(
      `[data-product-id='${productId}']`,
    );
    if (!productCard || !window.bundleManager) return;

    const quantityValue = productCard.querySelector(".quantity-value");
    const addBtn = productCard.querySelector(".add-to-bundle-btn");

    const quantity = parseInt(quantityValue?.textContent, 10) || 0;

    if (quantity === 0) {
      window.bundleManager.handleAddToBundle(addBtn);
      const newQuantity = parseInt(quantityValue?.textContent, 10) || 0;
      const popupAddBtn = bundlePopup.querySelector(".add-to-bundle-btn");
      const popupQuantitySelector =
        bundlePopup.querySelector(".quantity-selector");
      const popupQuantityValue = bundlePopup.querySelector(".quantity-value");
      window.bundleManager.updateFreeTagVisibility();
      updatePopupUI(
        newQuantity,
        popupAddBtn,
        popupQuantitySelector,
        popupQuantityValue,
      );
    }
  };

  document.addEventListener("click", (event) => {
    const target = event.target;
    const plusIcon = target.closest(".plus-icon-split");
    const productCard = target.closest(
      ".product-card__image-wrapper [data-product-card-link]",
    );
    const isClose = target.closest(".bundle-popup .cross-icon");
    const isOverlay = target.closest(".bundle-popup .overlay");
    const isAddBtn = target.closest(".bundle-popup .add-to-bundle-btn");

    if (plusIcon) {
      event.preventDefault();
      const productCardWrapper = plusIcon.closest(
        ".product-card__image-wrapper",
      );
      if (productCardWrapper) {
        const cardLink = productCardWrapper.querySelector(
          "[data-product-card-link][data-bundle-product]",
        );
        if (cardLink) {
          openPopup(
            cardLink.dataset.bundleProduct,
            cardLink.dataset.subTitle,
            cardLink.dataset.infoDescription,
          );
        }
      }
      return;
    }

    if (productCard) {
      event.preventDefault();
      openPopup(
        productCard.dataset.bundleProduct,
        productCard.dataset.subTitle,
        productCard.dataset.infoDescription,
      );
      return;
    }

    if (isClose || isOverlay) {
      closePopup();
      return;
    }

    if (isAddBtn) {
      event.preventDefault();
      handlePopupAddToBundle();
    }
  });
};

const updateBundleContentVisibility = () => {
  const leftEye = document.getElementById("left-eye")?.value.trim();
  const rightEye = document.getElementById("right-eye")?.value.trim();
  const bundleSelected = document.querySelector('input[name="bundle"]:checked');
  const summaryVisible = document
    .querySelector(".product-personalization__summary-wrapper")
    ?.classList.contains("is-visible");

  const isVisible = leftEye && rightEye && bundleSelected && summaryVisible;

  const elementsToToggle = [
    document.querySelector(".collection-content.bundle-content"),
    document.querySelector(".product-personalization__filter-section"),
  ];

  elementsToToggle.forEach((el) => {
    if (el) {
      el.classList.toggle("hide", !isVisible);
    }
  });
};

document.addEventListener("DOMContentLoaded", () => {
  updateBundleContentVisibility();
  handleBundlePopup();
});
